export default
	[
		{
			path: '/setup',
			name: 'setup',
			redirect: { name: 'setup.type' },
			component: () => import('@views/setup/Index.vue'),
			children: [
				{
					path: 'type',
					name: 'setup.type',
					component: () => import('@views/setup/Type.vue'),
				},
				{
					path: 'info',
					name: 'setup.info',
					component: () => import('@views/setup/Info.vue'),
				},
				{
					path: 'availability',
					name: 'setup.availability',
					component: () => import('@views/setup/Availability.vue'),
				},
				{
					path: 'brand',
					name: 'setup.brand',
					component: () => import('@views/setup/Brand.vue'),
				},	
				{
					path: 'finish',
					name: 'setup.finish',
					component: () => import('@views/setup/Finish.vue'),
				},	
			]
		}
	]
